import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SetupResellerRewardCreatePageRoutingModule } from './setup-reseller-reward-create-routing.module';

import { SetupResellerRewardCreatePage } from './setup-reseller-reward-create.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SetupResellerRewardCreatePageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [SetupResellerRewardCreatePage]
})
export class SetupResellerRewardCreatePageModule {}
